import React from "react";
//MUI Components
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
//custom components
import ScoreDetails from "./scoreDetails";

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
}));

function TopPerformers(props) {
  return (
    <>
      <Box>
        {/*title*/}
        <Typography
          variant="h5"
          sx={{
            color: "#ffffff",
            marginBottom: "-0.3rem",
            textAlign: { lg: "left", md: "center", sm: "center", xs: "center" },
            marginTop: "1.5rem",
            fontSize: { lg: "2rem" },
          }}
        >
          Top Performers
        </Typography>
      </Box>
      {/*top performers boxes*/}
      <Box sx={{ marginTop: "2rem", marginBottom: "1rem" }}>
        {/*stack*/}
        <Stack
          direction={{ xl: "row", lg: "row", md: "col", sm: "col", xs: "col" }}
          spacing={{ lg: 7, md: 5 }}
          sx={{ marginTop: "-1rem" }}
          alignItems="center"
        >
          {/*first perfromer!!*/}
          <Item
            sx={{
              backgroundColor: "#75FDC6",
              width: { lg: "25rem", md: "23rem", sm: "22rem", xs: "18rem" },
              height: { lg: "12rem", xs: "11rem" },
              borderRadius: "0.8rem",
            }}
          >
            {/*score box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "14rem",
                  md: "14rem",
                  sm: "15.5rem",
                  xs: "12rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  fontWeight: "bolder",
                  fontSize: {
                    lg: "2.4rem",
                    md: "2.2rem",
                    sm: "2.1rem",
                    xs: "1.9rem",
                  },
                  marginTop: "0.8rem",
                }}
              >
                {props.data[0].total === null ? "#" : props.data[0].total}
              </Typography>
            </Box>
            {/*name and avtar box*/}
            <Box sx={{}}>
              <Grid
                container
                spacing={3}
                sx={{
                  marginLeft: "0.1rem",
                  width: "21rem",
                  marginTop: { lg: "-2rem", sm: "-2.5rem", xs: "-1.6rem" },
                }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      marginTop: "0.5rem",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "1.5rem",
                        md: "1.5rem",
                        sm: "1.5rem",
                        xs: "1.3rem",
                      },
                      letterSpacing: "0.1rem",
                    }}
                  >
                    {props.data[0].teamName === null
                      ? "#"
                      : props.data[0].teamName}
                  </Typography>{" "}
                </Grid>
              </Grid>
            </Box>
            {/*Rank box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "15rem",
                  md: "15rem",
                  sm: "15.5rem",
                  xs: "13rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  marginTop: "-0.1rem",
                  fontSize: { lg: "2.3rem", xs: "2rem" },
                  fontWeight: "bold",
                }}
              >
                {props.data[0].rank === null
                  ? "#"
                  : props.state == false
                  ? "#"
                  : 1}
              </Typography>
            </Box>
            {/*divider*/}
            <Divider
              variant="middle"
              sx={{ color: "red", marginTop: { md: "-0.8", xs: "-0.2rem" } }}
            ></Divider>
            {/*details section*/}
            <Box>
              <Typography
                sx={{
                  marginTop: { lg: "0.2rem", sm: "0.3rem", xs: "0.2rem" },
                  fontSize: { sm: "1.1rem", xs: "1rem" },
                }}
              >
                <ScoreDetails
                  color={"#75FDC6"}
                  teamName={props.data[0].teamName}
                  round1={props.data[0].round1}
                  round2={props.data[0].round2}
                  total={props.data[0].total}
                ></ScoreDetails>
              </Typography>
            </Box>
          </Item>

          {/*second performer!!*/}
          <Item
            sx={{
              backgroundColor: "#4EFBD7",
              width: { lg: "30rem", md: "23rem", sm: "22rem", xs: "18rem" },
              height: { lg: "12rem", xs: "11rem" },
              borderRadius: "0.8rem",
              position: { md: "relative", sm: "relative", xs: "relative" },
              top: { lg: "0", md: "2rem", sm: "3rem", xs: "4rem" },
            }}
          >
            {/*score box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "15rem",
                  md: "15rem",
                  sm: "15.5rem",
                  xs: "12rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  fontWeight: "bolder",
                  fontSize: {
                    lg: "2.4rem",
                    md: "2.2rem",
                    sm: "2.1rem",
                    xs: "1.9rem",
                  },
                  marginTop: "0.8rem",
                }}
              >
                {props.data[1].total === null ? "#" : props.data[1].total}
              </Typography>
            </Box>
            {/*name and avtar box*/}
            <Box sx={{}}>
              <Grid
                container
                spacing={3}
                sx={{
                  marginLeft: "0.1rem",
                  width: "21rem",
                  marginTop: { lg: "-2rem", sm: "-2.5rem", xs: "-1.6rem" },
                }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      marginTop: "0.5rem",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "1.5rem",
                        md: "1.5rem",
                        sm: "1.5rem",
                        xs: "1.2rem",
                      },
                      letterSpacing: "0.1rem",
                    }}
                  >
                    {props.data[1].teamName === null
                      ? "#"
                      : props.data[1].teamName}
                  </Typography>{" "}
                </Grid>
              </Grid>
            </Box>
            {/*Rank box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "15rem",
                  md: "15rem",
                  sm: "15.5rem",
                  xs: "13rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  marginTop: "-0.1rem",
                  fontSize: { lg: "2.3rem", xs: "2rem" },
                  fontWeight: "bold",
                }}
              >
                {props.data[1].rank === null
                  ? "#"
                  : props.state == false
                  ? "#"
                  : 2}
              </Typography>
            </Box>
            {/*divider*/}
            <Divider
              variant="middle"
              sx={{ color: "red", marginTop: { md: "-0.8", xs: "-0.2rem" } }}
            ></Divider>
            {/*details section*/}
            <Box>
              <Typography
                sx={{
                  marginTop: { lg: "0.2rem", sm: "0.3rem", xs: "0.2rem" },
                  fontSize: { sm: "1.1rem", xs: "1rem" },
                }}
              >
                <ScoreDetails
                  teamName={props.data[1].teamName}
                  round1={props.data[1].round1}
                  round2={props.data[1].round2}
                  total={props.data[1].total}
                ></ScoreDetails>
              </Typography>
            </Box>
          </Item>

          {/*third performer!!*/}
          <Item
            sx={{
              backgroundColor: "#6FF4BE",
              width: { lg: "25rem", md: "23rem", sm: "22rem", xs: "18rem" },
              height: { lg: "12rem", xs: "11rem" },
              borderRadius: "0.8rem",
              position: { md: "relative", sm: "relative", xs: "relative" },
              top: { lg: "0", md: "4rem", sm: "6rem", xs: "8rem" },
            }}
          >
            {/*score box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "14rem",
                  md: "14rem",
                  sm: "15.5rem",
                  xs: "12rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  fontWeight: "bolder",
                  fontSize: {
                    lg: "2.4rem",
                    md: "2.2rem",
                    sm: "2.1rem",
                    xs: "1.9rem",
                  },
                  marginTop: "0.8rem",
                }}
              >
                {props.data[2].total === null ? "#" : props.data[2].total}
              </Typography>
            </Box>
            {/*name and avtar box*/}
            <Box sx={{}}>
              <Grid
                container
                spacing={3}
                sx={{
                  marginLeft: "0.1rem",
                  width: "21rem",
                  marginTop: { lg: "-2rem", sm: "-2.5rem", xs: "-1.6rem" },
                }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      marginTop: "0.5rem",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "1.5rem",
                        md: "1.5rem",
                        sm: "1.5rem",
                        xs: "1.3rem",
                      },
                      letterSpacing: "0.1rem",
                    }}
                  >
                    {props.data[2].teamName === null
                      ? "#"
                      : props.data[2].teamName}
                  </Typography>{" "}
                </Grid>
              </Grid>
            </Box>
            {/*Rank box*/}
            <Box
              sx={{
                position: "relative",
                left: {
                  lg: "15rem",
                  md: "15rem",
                  sm: "15.5rem",
                  xs: "13rem",
                  width: "7rem",
                },
              }}
            >
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  marginTop: "-0.1rem",
                  fontSize: { lg: "2.3rem", xs: "2rem" },
                  fontWeight: "bold",
                }}
              >
                {props.data[2].rank === null
                  ? "#"
                  : props.state == false
                  ? "#"
                  : 3}
              </Typography>
            </Box>
            {/*divider*/}
            <Divider
              variant="middle"
              sx={{ color: "red", marginTop: { md: "-0.8", xs: "-0.2rem" } }}
            ></Divider>
            {/*details section*/}
            <Box>
              <Typography
                sx={{
                  marginTop: { lg: "0.2rem", sm: "0.3rem", xs: "0.2rem" },
                  fontSize: { sm: "1.1rem", xs: "1rem" },
                }}
              >
                <ScoreDetails
                  teamName={props.data[2].teamName}
                  round1={props.data[2].round1}
                  round2={props.data[2].round2}
                  total={props.data[2].total}
                ></ScoreDetails>
              </Typography>
            </Box>
          </Item>
        </Stack>
      </Box>
    </>
  );
}
export default TopPerformers;
